import { useState } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { usePromoCodes } from "@/hooks/usePromoCodes";
import { BadgePercent } from "lucide-react";

export default function Promotions() {
  const [code, setCode] = useState("");
  const [result, setResult] = useState<any>(null);
  const { validate, validating } = usePromoCodes();

  const onCheck = async () => {
    if (!code.trim()) return;
    const r = await validate(code.trim());
    setResult(r);
  };

  return (
    <div className="container mx-auto p-6 max-w-2xl">
      <h1 className="text-3xl font-bold mb-6 flex items-center gap-2"><BadgePercent className="h-7 w-7" />Promotions</h1>
      <Card>
        <CardHeader><CardTitle>Check a Promo Code</CardTitle></CardHeader>
        <CardContent className="space-y-4">
          <div className="flex gap-2">
            <Input placeholder="Enter promo code" value={code} onChange={(e) => setCode(e.target.value.toUpperCase())} />
            <Button onClick={onCheck} disabled={validating}>Check</Button>
          </div>
          {result && (
            <div className={`p-4 rounded border ${result.valid ? "bg-green-50 border-green-200" : "bg-red-50 border-red-200"}`}>
              {result.valid ? (
                <>
                  <Badge className="mb-2">Valid</Badge>
                  <p className="font-semibold">{result.promo.discount_percent}% off</p>
                  {result.promo.valid_until && <p className="text-xs text-muted-foreground">Valid until {new Date(result.promo.valid_until).toLocaleDateString()}</p>}
                </>
              ) : (
                <p className="text-sm text-red-700">{result.error}</p>
              )}
            </div>
          )}
          <p className="text-xs text-muted-foreground">Promo codes can be applied at checkout (coming soon).</p>
        </CardContent>
      </Card>
    </div>
  );
}
